import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Tax } from "../state/types"

export const useTaxActions = () => {
    const saveActions = useSaveActions()

    const saveTax = (tax: Tax) => {
        const { save } = saveActions()
        return save(TableName.TAXES, tax) as Promise<Tax>
    }

    const removeTax = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.TAXES, id)
    }

    return {
        saveTax,
        removeTax
    }
}
